import {
  Box,
  Flex,
  Link,
  Image,
  IconButton,
  Theme,
  Icon,
} from "@chakra-ui/react";
import {
  DrawerActionTrigger,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerRoot,
  DrawerTrigger,
} from "..//ui/drawer";
import { CgMenuRight } from "react-icons/cg";

import { Link as RouterLink } from "react-router-dom";
import { useEffect, useState } from "react";
import SingleMenuItem from "./SingleMenuItem";
import OutlineButton from "./OutlineButton";

const Header = () => {
  const [open, setOpen] = useState(false);
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  return (
    <>
      <Flex
        as="header"
        justifyContent={{
          base: "space-between",
          md: isScrolled ? "center" : "space-between",
        }}
        alignItems="center"
        wrap="wrap"
        py={isScrolled ? "3" : "2"}
        px={{ base: "4", md: "10" }}
        w="full"
        bgColor={{
          base: isScrolled ? "#a20c0b" : "transparent",
          md: "transparent",
        }}
        pos="fixed"
        zIndex="9999"
        top="0"
        left="0"
        transition="all 0.3s ease"
      >
        {/* Logo */}
        <Link
          as={RouterLink}
          to="/"
          color="white"
          fontWeight="bold"
          letterSpacing="wide"
          _hover={{ textDecor: "none", color: "white" }}
          px="2"
          display={{ base: "block", md: isScrolled ? "none" : "block" }}
          onClick={() => {
            window.scrollTo({ top: "0", behavior: "smooth" });
          }}
          _focus={{ outline: "none" }}
        >
          <Image
            objectFit="fill"
            w={{ base: "200px", md: "200px", lg: "250px" }}
            src="../assets/logo.png"
            alt="logo"
          />
        </Link>

        {/* Links */}
        <Box
          bgColor={isScrolled ? "#a20c0b" : "transparent"}
          borderRadius="full"
        >
          <Box
            display={{ base: "none", md: "flex" }}
            width={{
              base: "full",
              md: isScrolled ? "650px" : "350px",
              lg: isScrolled ? "650px" : "500px",
            }}
            justifyContent="space-evenly"
            border={isScrolled ? "1px solid #a20c0b" : "none"}
            borderRadius="full"
            p={2}
            bgColor={isScrolled ? "#ffffff30" : "transparent"}
            boxShadow={isScrolled ? "rgba(0, 0, 0, 0.24) 0px 2px 3px;" : "none"}
            backdropFilter={isScrolled ? "blur(40px)" : "none"}
            // mr={isScrolled ? "none" : "32"}
          >
            <SingleMenuItem label="ABOUT US" url="/about" />
            <SingleMenuItem label="SERVICES" url="/services" />
            <SingleMenuItem
              label="BLOG"
              url="https://learningwithme99.blogspot.com/"
              target="_blank"
            />
            <SingleMenuItem label="CONTACT" url="/contact" />
            <Box
              display={{
                base: "none",
                md: isScrolled ? "block" : "none",
              }}
            >
              <OutlineButton
                title="Lets Connect"
                url="https://api.whatsapp.com/send/?phone=919152832898"
                color="white"
                borderColor="white"
                target="_blank"
              />
            </Box>
          </Box>
        </Box>

        {/* Phone Number */}
        <Box
          display={{
            base: "none",
            md: isScrolled ? "none" : "block",
          }}
        >
          <OutlineButton
            px="5"
            title="Lets Connect"
            url="https://api.whatsapp.com/send/?phone=919152832898"
            color="white"
            borderColor="white"
            target="_blank"
          />
        </Box>

        {/* Mobile Drawer */}
        <Box display={{ base: "block", md: "none" }}>
          <DrawerRoot
            size="full"
            open={open}
            onOpenChange={(e) => setOpen(e.open)}
          >
            <DrawerTrigger asChild>
              <IconButton
                bgColor="transparent"
                color={"white"}
                display={open ? "none" : "block"}
              >
                <Icon boxSize="7">
                  <CgMenuRight />
                </Icon>
              </IconButton>
            </DrawerTrigger>
            <DrawerContent bgColor="#a20c0b">
              <DrawerBody mt={28}>
                <DrawerActionTrigger>
                  <Flex direction="column" gap={10}>
                    <SingleMenuItem label="HOME" url="/" />
                    <SingleMenuItem label="ABOUT US" url="/about" />
                    <SingleMenuItem label="SERVICES" url="/services" />
                    <SingleMenuItem
                      label="BLOG"
                      url="https://learningwithme99.blogspot.com/"
                      target="_blank"
                    />
                    <SingleMenuItem label="CONTACT" url="/contact" />
                  </Flex>
                </DrawerActionTrigger>
              </DrawerBody>
              <Theme appearance="dark">
                <DrawerCloseTrigger />
              </Theme>
            </DrawerContent>
          </DrawerRoot>
        </Box>
      </Flex>
    </>
  );
};

export default Header;
